import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React from "react";

export default function DeleteCart({
  isOpen,
  onClose,
  name,
  img,
  qty,
  handleDelete,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Konfirmasi Delete</ModalHeader>
        <ModalCloseButton />
        <hr />
        <ModalBody>
          <Box py="1">
            <Box py="2">
              <Text fontWeight="600" fontSize="20px" textAlign="center" py="2">
                Apakah anda yakin akan menghapus barang ini ?
              </Text>
              <Box display="flex" px="10">
                <img
                  src={img}
                  alt="items"
                  style={{
                    border: "1px solid #E0E0E0",
                    borderRadius: "10px",
                    maxHeight: "150px",
                    minHeight: "100px",
                    maxWidth: "150px",
                    minWidth: "100px",
                  }}
                />
                <VStack
                  align="baseline"
                  justifyContent="center"
                  spacing={2}
                  px="3"
                >
                  <Text fontWeight="500" fontSize="20px">
                    {name}
                  </Text>
                  <Text color="#B9B9B9">{qty} barang</Text>
                </VStack>
              </Box>
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Close
          </Button>
          <Button colorScheme="red" onClick={handleDelete}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
